import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import store from './app/store';
import App from './App';
import './index.css';
import { AppThemeProvider } from './theme/ThemeModeProvider';
import { TenantProvider } from './tenancy/TenantProvider';

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
const queryClient = new QueryClient();

root.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <TenantProvider>
        <AppThemeProvider>
          <App />
        </AppThemeProvider>
      </TenantProvider>
    </QueryClientProvider>
  </Provider>
);

